/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ZipUrl
 */
export interface ZipUrl {
    /**
     * 
     * @type {string}
     * @memberof ZipUrl
     */
    url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ZipUrl
     */
    fileName?: string | null;
}

export function ZipUrlFromJSON(json: any): ZipUrl {
    return ZipUrlFromJSONTyped(json, false);
}

export function ZipUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): ZipUrl {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function ZipUrlToJSON(value?: ZipUrl | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'fileName': value.fileName,
    };
}


